import { render, staticRenderFns } from "./EvidenceImage.vue?vue&type=template&id=efb20a34&scoped=true&"
import script from "./EvidenceImage.vue?vue&type=script&lang=ts&"
export * from "./EvidenceImage.vue?vue&type=script&lang=ts&"
import style0 from "./EvidenceImage.vue?vue&type=style&index=0&id=efb20a34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb20a34",
  null
  
)

export default component.exports